

































































import { computed, ComputedRef, defineComponent } from "@vue/composition-api";
import { useActions, useGetters } from "vuex-composition-helpers";
import { ActionTree, GetterTree } from "vuex";
import { MyStudyChoiceOnboardingModelState } from "@/apps/MyStudyChoiceOnboardingWidget/models/store-viewmodel";
import InputAtom from "@/shared/components/atoms/InputAtom.vue";
import HeaderImage from "@/apps/MyStudyChoiceOnboardingWidget/components/steps/atoms/HeaderImage.vue";

export default defineComponent({
  name: "WelcomeStep",
  components: { HeaderImage, InputAtom },
  setup: () => {
    const { setCanContinue, setMyStudyChoice } = useActions<
      ActionTree<
        MyStudyChoiceOnboardingModelState,
        MyStudyChoiceOnboardingModelState
      >
    >(["setCanContinue", "setMyStudyChoice"]);
    const { getLabels, getMyStudyChoice } = useGetters<
      GetterTree<
        MyStudyChoiceOnboardingModelState,
        MyStudyChoiceOnboardingModelState
      >
    >(["getLabels", "getMyStudyChoice"]);
    const myStudyChoice: ComputedRef<string> = computed(
      (): string => getMyStudyChoice.value ?? ""
    );
    if (!myStudyChoice.value) {
      setCanContinue(false);
    }

    return {
      getLabels,
      myStudyChoice,
      setMyStudyChoice,
      setCanContinue,
    };
  },
});
